export const transformElement = (element) => ($, additionalProps, mutationFunctions) => {
    $(element).each((_, el) => {
        const $el = $(el);
        mutationFunctions.forEach((mutator) => mutator($el, additionalProps));
    });
    return $;
};
//# sourceMappingURL=transform-element.js.map